import { Page } from '@react-pdf/renderer'
import { ReactNode } from 'react'

import { pagePdfStyles } from '@features/exports/utils/pagePdfStyles'

import { useReportsPdfDocument } from '../../contexts/reportsPdfDocumentContext'
import { getPageOrientation } from './utils/getPageOrientation'

interface ReportsPdfPageProps {
  children: ReactNode
}

export const ReportsPdfPage = ({ children }: ReportsPdfPageProps) => {
  const context = useReportsPdfDocument()

  const orientation = getPageOrientation(context)

  return (
    <Page size="A4" wrap style={pagePdfStyles.page} orientation={orientation}>
      {children}
    </Page>
  )
}
